import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Feedback, Button, Link, Flexer, Tag, Spacer, Text, ButtonRound } from '@ontruck/orc';
import VehicleInfo from 'modules/journey/map/VehicleInfo';
import { loadingElement } from 'modules/google-maps/elements';
import { Loading } from 'components/Loading';

import tel from 'utils/phone';
import { ServiceTagFTC } from 'components/ServiceTag';

const t = {
  position: 'Position',
  has_jobs: 'Has some job assigned',
  no_jobs: 'No jobs assigned',
  no_vehicles: 'No vehicles',
  meters: 'm',
  assign: 'Assign job',
  assigned: 'Assigned to',
  carrier_vehicles: 'Carrier vehicles',
  carrier: 'Carrier:',
  error: 'Error assigning',
};

const DriverInfo = ({
  className,
  onClose,
  timestamp,
  locationMode,
  driver,
  carrier,
  vehicles,
  openCarrierPage,
  isLoading,
  isAssigning,
  isDone,
  isError,
  handleAssignment,
}) => {
  const closeButton = (
    <div className="close-button">
      <ButtonRound skin="primary" size="XS" onClick={onClose} icon="close" />
    </div>
  );

  if (isLoading) {
    return (
      <div className={className}>
        {closeButton}
        {loadingElement}
      </div>
    );
  }

  if (!driver) {
    return null;
  }

  const fromWhat = moment(timestamp * 1000);

  return (
    <Spacer p="M" className={className}>
      {closeButton}
      <Flexer.Parent mBottom="XS" alignItems="center">
        {!!carrier.group && carrier.group !== 'DEFAULT' && (
          <Flexer.Child mRight="S">
            <Tag skin="dark" weight="bold" textTransform="uppercase">
              {carrier.group}
            </Tag>
          </Flexer.Child>
        )}
        {!carrier?.is_ftc && <ServiceTagFTC />}
        <Flexer.Child>
          <Link
            skin="primary"
            text={<Text text={driver.contact_name} display="block" size={'XL'} />}
            onClick={openCarrierPage}
          />
        </Flexer.Child>
      </Flexer.Parent>
      <Spacer mBottom="XS" alignItems="center">
        <Link skin="primary" href={tel(driver.contact_phone)} text={driver.contact_phone} />
      </Spacer>

      <Spacer>
        {t.carrier} {carrier.name}
      </Spacer>
      {fromWhat.isValid() && (
        <div>
          {t.position} {fromWhat.fromNow()}
        </div>
      )}
      <Spacer mBottom="M">
        {locationMode === 'hard' && <div>{t.has_jobs}</div>}
        {locationMode === 'soft' && <div>{t.no_jobs}</div>}
      </Spacer>
      <Text display="block" text={t.carrier_vehicles} size="L" />
      {!(vehicles || []).length && <Spacer>{t.no_vehicles}</Spacer>}
      {vehicles.map((vehicle) => (
        <VehicleInfo key={vehicle.id} vehicle={vehicle} country={carrier.country} />
      ))}

      <Spacer mTop="M">
        {!isDone && !isError && (
          <Button text={t.assign} fullWidth onClick={handleAssignment} disabled={isAssigning} />
        )}
        {isDone && (
          <Feedback size="wideS" skin="success">
            {t.assigned} {driver.contact_name}
          </Feedback>
        )}
        {isError && (
          <Feedback size="wideS" skin="error">
            {t.error}
          </Feedback>
        )}
      </Spacer>

      {isAssigning && (
        <Flexer.Parent mTop="S" alignItems="center" justifyContent="center">
          <Loading />
        </Flexer.Parent>
      )}
    </Spacer>
  );
};

DriverInfo.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  timestamp: PropTypes.number,
  locationMode: PropTypes.string,
  driver: PropTypes.shape({}),
  carrier: PropTypes.shape({}),
  vehicles: PropTypes.arrayOf(PropTypes.shape({})),
  openCarrierPage: PropTypes.func,
  isLoading: PropTypes.bool,
  isAssigning: PropTypes.bool,
  isDone: PropTypes.bool,
  isError: PropTypes.bool,
  handleAssignment: PropTypes.func,
};

export default DriverInfo;
